import { FileText } from 'lucide-react';

const MembershipTerms = () => {
  return (
    <div className="min-h-screen py-24" data-testid="membership-terms-page">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="text-center mb-12">
          <FileText size={48} className="mx-auto mb-4" style={{ color: '#D4AF37' }} />
          <h1 className="text-4xl font-bold mb-4" style={{ color: '#ffffff' }}>
            Membership Terms & Conditions
          </h1>
          <p className="text-muted-foreground">Last updated: January 2025</p>
        </div>

        <div className="glass-panel rounded-2xl p-8 border space-y-8">
          <section>
            <h2 className="text-2xl font-bold mb-4" style={{ color: '#D4AF37' }}>1. Membership Overview</h2>
            <p className="text-muted-foreground leading-relaxed">
              Blendonics offers three membership tiers: Starter, Pro, and Elite. Each tier provides access to different levels of content, community features, and coaching services as described on our pricing page.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4" style={{ color: '#D4AF37' }}>2. Subscription Billing</h2>
            <ul className="text-muted-foreground leading-relaxed space-y-2 list-disc list-inside">
              <li>Membership subscriptions are billed monthly on the date of your initial subscription.</li>
              <li>Payments are processed securely through Stripe.</li>
              <li>You will receive an email confirmation for each payment.</li>
              <li>Prices are displayed in GBP (£) and include applicable taxes.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4" style={{ color: '#D4AF37' }}>3. Cancellation Policy</h2>
            <ul className="text-muted-foreground leading-relaxed space-y-2 list-disc list-inside">
              <li>You may cancel your membership at any time from your account dashboard.</li>
              <li>Upon cancellation, you will retain access to membership benefits until the end of your current billing period.</li>
              <li>After the billing period ends, your account will be downgraded to Free tier.</li>
              <li>No partial refunds are provided for unused portions of a billing period.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4" style={{ color: '#D4AF37' }}>4. Refund Policy</h2>
            <p className="text-muted-foreground leading-relaxed">
              Monthly subscription payments are non-refundable. If you experience technical issues preventing access to membership content, please contact our support team at contact@blendonics.com within 7 days of the charge.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4" style={{ color: '#D4AF37' }}>5. Account Responsibilities</h2>
            <ul className="text-muted-foreground leading-relaxed space-y-2 list-disc list-inside">
              <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
              <li>Membership access is for personal use only and may not be shared with others.</li>
              <li>Violation of community guidelines may result in account suspension or termination.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4" style={{ color: '#D4AF37' }}>6. Content Access</h2>
            <p className="text-muted-foreground leading-relaxed">
              Access to specific content and features depends on your membership tier. Content availability may change as we update and improve our platform. We reserve the right to modify, add, or remove content at our discretion.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4" style={{ color: '#D4AF37' }}>7. Contact Us</h2>
            <p className="text-muted-foreground leading-relaxed">
              For questions about these terms or your membership, please contact us at{' '}
              <a href="mailto:contact@blendonics.com" style={{ color: '#D4AF37' }}>contact@blendonics.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default MembershipTerms;
